// New barrel over the Investigation registry key's two epic modules (plan
// §3: "the structural gift... one barrel must be created"; this is the
// 145th Phase-3 conversion target). `src/epics.js` previously imported
// `AccountInvestigation/epics` and `ThreatLog/epics` separately with no
// combined key of their own; this barrel gives the `Investigation` registry
// key a single epic to inject/eject.
//
// Plain `combineEpics` for now, matching every other route barrel prior to
// task #6 — converting to `combineEpicsIsolated` here would add per-leaf
// error isolation ahead of schedule and suppress the `pageerror` signal the
// pre-fix RED capture (task #3) still needs to observe.
import { combineEpicsIsolated } from 'utils/epicRegistry'

import accountInvestigationEpic from './AccountInvestigation/epics'
import threatLogEpic from './ThreatLog/epics'

export default combineEpicsIsolated(accountInvestigationEpic, threatLogEpic)
